// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lists":"app-components-staticpages-blocks-tracklistsblock--lists"};